<div class="page-container">
  <!-- HEADER -->
  <header class="page-header">
    <span class="eyebrow">Platform Terms</span>
    <h1 class="page-title">Terms & Conditions</h1>
    <p class="page-subtitle">
      Governing rules, rights, and obligations for using the Aluguloo heavy equipment rental marketplace.
    </p>

    <!-- TABS -->
    <div class="tabs-bar">
      <button 
        class="tab-btn" 
        [class.active]="activeTab === 'general'" 
        (click)="setTab('general')">
        General Terms
      </button>
      <button 
        class="tab-btn" 
        [class.active]="activeTab === 'customer'" 
        (click)="setTab('customer')">
        Customer Terms
      </button>
      <button 
        class="tab-btn" 
        [class.active]="activeTab === 'vendor'" 
        (click)="setTab('vendor')">
        Vendor Terms
      </button>
    </div>
  </header>

  <!-- CONTENT -->
  <main class="document-content">
    <!-- GENERAL TAB -->
    <div *ngIf="activeTab === 'general'">
      <section class="doc-section">
        <h2>1. About Aluguloo.com</h2>
        <p>
          Aluguloo.com is a UAE-based online marketplace connecting construction contractors and hiring entities ("Customers") 
          with owners and fleet operators of heavy equipment and commercial vehicles ("Vendors").
        </p>
        <p>
          The platform is operated in association with <strong>Onixhu LLC</strong> ("Aluguloo", "we", "us", or "our"). 
          Aluguloo acts solely as an intermediary technology platform. It does not own, rent, inspect, or operate machinery, 
          and does not act as an agent or guarantor for any transaction.
        </p>
      </section>

      <section class="doc-section">
        <h2>2. Agreement Structure</h2>
        <p>
          These General Terms apply to all registered users. Role-specific terms apply in addition when you activate a Customer or Vendor account:
        </p>
        <ul>
          <li><strong>Tier 1:</strong> General Platform Terms (applicable to all users).</li>
          <li><strong>Tier 2A:</strong> Customer Terms & Conditions (applicable to hiring parties).</li>
          <li><strong>Tier 2B:</strong> Vendor Terms & Conditions (applicable to equipment owners).</li>
        </ul>
      </section>

      <section class="doc-section">
        <h2>3. Account Registration & Security</h2>
        <p>
          Users must be at least 18 years of age and hold valid UAE legal authorization. You are solely responsible for safeguard of your account credentials. 
          Notify platform administration immediately through your account security settings or verified dashboard if you suspect unauthorized access.
        </p>
      </section>

      <section class="doc-section">
        <h2>4. Financial Arrangements</h2>
        <p>
          All rental payments, mobilization deposits, and credit terms are agreed and settled directly between Customer and Vendor 
          under accepted Local Purchase Orders (LPOs). Aluguloo does not process or hold rental funds.
        </p>
      </section>

      <section class="doc-section">
        <h2>5. Governing Law</h2>
        <p>
          These terms and all platform usage are governed exclusively by the laws of the United Arab Emirates as applied in the Emirate of Dubai.
        </p>
      </section>
    </div>

    <!-- CUSTOMER TAB -->
    <div *ngIf="activeTab === 'customer'">
      <section class="doc-section">
        <h2>Customer Terms & Obligations</h2>
        <p>These terms govern registered users booking equipment on the platform:</p>
        <ul>
          <li><strong>Licensing:</strong> Customers must hold a valid UAE Trade License issued by the relevant authority.</li>
          <li><strong>Binding LPO:</strong> Confirming a booking or issuing an LPO constitutes a commercial commitment to hire.</li>
          <li><strong>Site Readiness:</strong> Customers must ensure clear site access, firm ground, and necessary entry passes.</li>
          <li><strong>Timesheets:</strong> Site supervisors must verify and sign off daily working logs in a timely manner.</li>
        </ul>
      </section>
    </div>

    <!-- VENDOR TAB -->
    <div *ngIf="activeTab === 'vendor'">
      <section class="doc-section">
        <h2>Vendor Terms & Obligations</h2>
        <p>These terms govern equipment owners and fleet operators listing assets on the platform:</p>
        <ul>
          <li><strong>Fleet Standards:</strong> All machinery must be fully operational and carry valid UAE registration (Mulkiya).</li>
          <li><strong>Insurance:</strong> Vendors must maintain active commercial insurance covering machinery and third-party liabilities.</li>
          <li><strong>Certified Operators:</strong> For "with operator" hires, drivers must hold valid UAE heavy machinery licenses.</li>
          <li><strong>Rate Accuracy:</strong> Published rental rates and availability calendars must be kept accurate and up to date.</li>
        </ul>
      </section>
    </div>
  </main>
</div>
